<template>
    <div class="EquipmentElectricity" >
        <Title firstName="月能耗排名" lastName="ENERGY CONSUMPTION RANKING"/>
        <div class="echarts">
            <div class="chart">
                <div id="dom"></div>
            </div>
            <div class="top">
                月能耗折标煤：<span>{{(energyObj.total * 1).toFixed(3)}}</span> <span>tce</span> 
            </div>
            <div class="water">
                <div class="type">
                    <p>用水</p>
                    <p>{{Number(energyObj.waterSC / energyObj.total * 100).toFixed(3)}}<span>%</span></p>
                </div>
            </div>
            <div class="electricity">
                <div class="type">
                    <p>用电</p>
                    <p>{{Number(energyObj.energySC / energyObj.total * 100).toFixed(3)}}<span>%</span></p>
                </div>
            </div>
            <div class="cold">
                <div class="type">
                    <p>用冷</p>
                    <p>{{Number(energyObj.coolingSC / energyObj.total * 100).toFixed(3)}}<span>%</span></p>
                </div>
            </div>
            <div class="hot">
                <div class="type">
                    <p>用热</p>
                    <p>{{Number(energyObj.heatSC / energyObj.total * 100).toFixed(3)}}<span>%</span></p>
                </div>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../../components/title/Title')
const Graph = () => import('../../../../components/echarts/graph.vue')
const charts = () => import('../../../../components/echarts/charts.vue')
const SelectList = () => import('../../../../components/title/selectList.vue')

import * as echarts from 'echarts';
export default {
    props:{
    },
    data(){
        return {
            acindex:1,
            energyObj:{},
            rankList:[
                {
                    title:"主楼1F",
                    id:1,
                    ratioStyle:{
                        width:'100%' ,
                        background: '#5B8FF9'
                    },
                    val:6201
                },
                {
                    title:"主楼2F",
                    id:2,
                    ratioStyle:{
                        width:'70%' ,
                        background: '#F6BD16'
                    },
                    val:4311
                },
                {
                    title:"主楼3F",
                    id:3,
                    ratioStyle:{
                        width:'50%' ,
                        background: '#FF9D4D'
                    },
                    val:3155
                },
                {
                    title:"主楼4F",
                    id:4,
                    ratioStyle:{
                        width:'30%' ,
                        background: '#DCDCDC'
                    },
                    val:2000
                },
                {
                    title:"主楼5F",
                    id:5,
                    ratioStyle:{
                        width:'15%' ,
                        background: '#00E5EE'
                    },
                    val:1550
                },
                {
                    title:"主楼6F",
                    id:6,
                    ratioStyle:{
                        width:'5%' ,
                        background: '#54FF9F'
                    },
                    val:315
                },
                {
                    title:"主楼7F",
                    id:7,
                    ratioStyle:{
                        width:'1%' ,
                        background: '#87CEFA'
                    },
                    val:31
                },
            ],
            option: {
                tooltip: {
                    trigger: 'none',
                    show:false
                },
                color: ['#F7BE16', '#E76A4B', '#9271CB', '#6CCBEC'],
                legend: {
                    top: '5%',
                    left: 'center',
                    show:false
                },
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: ['50%', '95%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                            show: false,
                            fontSize: '40',
                            fontWeight: 'bold'
                            }
                        },
                        itemStyle: {
                            borderWidth: 2,
                            borderColor: 'rgba(0, 0, 0,0.5)',
                            borderMiterLimit:0,
                            shadowBlur :0
                        },
                        labelLine: {
                            show: false
                        },
                        data: []
                    }
                ]
            }
        }
    },
    components:{
        Title,Graph,charts,SelectList
    },
    mounted(){
        this.getListvalue()
    },
    methods:{
        changeIdx(idx){
            this.acindex = idx
        },
        initChart(){
            let myChart = echarts.init(document.getElementById('dom'));
            myChart.setOption(this.option);
        },
        async getListvalue(){
			let data = {
				dateRange:'MONTH',
				projectId:this.$store.state.projectId
			}
			let res = await this.$http.getConsumptionSC(data)
            this.energyObj = res.data.data.proportion
            this.option.series[0].data = [
                { value: Number(res.data.data.proportion.energySC).toFixed(2), name: '用电' },
                { value: Number(res.data.data.proportion.heatSC).toFixed(2), name: '用热' },
                { value: Number(res.data.data.proportion.coolingSC).toFixed(2), name: '用冷' },
                { value: Number(res.data.data.proportion.waterSC).toFixed(2), name: '用水' }
            ]
            this.initChart()
        }
    },
}
</script>

<style lang="less" scoped>
    .EquipmentElectricity{
        // height: 33.3vh;
        width: 20vw;
        // height: 493rem;
        position: fixed;
        top: 69.5vh;
        right: 2vw;
        z-index: 1;

        .echarts{
            position: relative;
            height: 23.5vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);
            overflow: hidden;
            padding-left: 0.5vw;
            
            .chart{
                width: 180rem;
                height: 180rem;
                position: absolute;
                top: 58%;
                left: 50%;
                transform: translate(-50%, -50%);
                #dom{
                    width: 100%;
                    height: 100%;
                }
            }

            .top{
                width: 260rem;
                height: 40rem;
                line-height: 40rem;
                text-align: center;
                position: absolute;
                top: 5%;
                left: 0%;
                right: 0%;
                margin: auto;
                border: 1px solid #348DF0;
                background: linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);
                font-size: 14rem;
                color:rgba(230,243,253, 0.7) ;
                &>span{
                    color:#00DEFF ;
                    font-size: 20rem;
                }
                &>span:last-child{
                    font-size: 14rem;
                }
            }

            .water{
                position: absolute;
                top: 30%;
                left: 10%;
            }
            .cold{
                position: absolute;
                bottom: 15%;
                left: 10%;
            }
            .electricity{
                position: absolute;
                top: 30%;
                right: 17%;
            }
            .hot{
                position: absolute;
                bottom: 15%;
                right: 17%;
            }
            .type{
                width: 2vw;
                height: 4vh;
                text-align: center;
                p:nth-child(1){
                    color: rgba(230,243,253, 0.7);
                    font-size: 14rem;
                }
                p:nth-child(2){
                    color: #00DEFF;
                    font-size: 20rem;
                    &>span{
                        font-size: 14rem;
                    }
                }
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }
    }
</style>